"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {PaveScaleCard} from "@/components/common/pave-scale-card";
import { useNavigate } from "react-router-dom";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Observatoire de l’Activité Touristique en Côte d’Ivoire"}
                                middleBreadcrumbs={[
                                    {title: "Pôle de l’Observation et des Etudes", link: "/espace-pro/pole-observation-etudes"},
                                ]}
                                description={"L’approche du tourisme est économique et sous cet angle, le tourisme s’entend des activités des personnes appelées visiteurs."}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">
                <div className={"grid grid-cols-1 md:grid-cols-4 gap-4"}>
                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Bulletin-ASTATS-2022-BULLETIN_ANAC_6-1.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-civ/1.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Bulletin-2019-Bulletin-des-statistiques_2019_MTL_23-Mars-2220.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-civ/2.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Bulletin-des-statistiques_2020_27-mars-1.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-civ/3.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>

                    <PaveScaleCard title={<></>} buttonLabel={"Télécharger"} className={"h-[400px] items-center text-center"}
                                   link="/pdf-viewer/Bulletin-2021-Bulletin-Statistiques-Tourisme-2021-5.pdf"
                                   image={"/images/espace-pro/pole-observation-etudes/observatoire-activite-toursistique-civ/4.jpg"}
                                   titleClassName={"font-exo font-bold text-2xl mb-16"}/>
                </div>
            </SectionPage>

        </div>
    );
}
